import { useEffect, useMemo, useState } from "react";

import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import SmallLoading from "../../Componentes/Utils/SmallLoading";

import { useModal } from "../../contexts/ModalContext";
import { useToast } from "../../contexts/ToastContext";
import useApi from "../../hooks/useApi";

// Normaliza qualquer formato de data ("YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss" ou
// objeto Date) para "YYYY-MM-DD", que é o que o <input type="date"> aceita.
const toInputDate = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value.slice(0, 10);
    if (value instanceof Date && !isNaN(value)) {
        return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
    }
    return '';
};

const ModalEditFolga = ({ folga, fetchData }) => {

    const { closeModal } = useModal();
    const { notifySuccess, notifyError } = useToast();
    const api = useApi();

    const [loading, setLoading] = useState(false);

    const [dataFolga, setDataFolga] = useState(toInputDate(folga?.data));
    const [dataPagamento, setDataPagamento] = useState(toInputDate(folga?.data_pagamento));

    const competenciaAtual = useMemo(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    }, []);

    const competenciaPagamentoOriginal = toInputDate(folga?.data_pagamento).slice(0, 7);

    const pagamentoEditavel = useMemo(() => {
        if (!competenciaPagamentoOriginal) return true;
        return competenciaPagamentoOriginal >= competenciaAtual;
    }, [competenciaPagamentoOriginal, competenciaAtual]);

    useEffect(() => {
        setDataFolga(toInputDate(folga?.data));
        setDataPagamento(toInputDate(folga?.data_pagamento));
    }, [folga]);

    const handleChangeDataFolga = (value) => {
        setDataFolga(value);

        if (pagamentoEditavel && value) {
            const base = new Date(`${value}T00:00:00`);
            base.setDate(base.getDate() - 60);
            const sugerido = `${base.getFullYear()}-${String(base.getMonth() + 1).padStart(2, '0')}-${String(base.getDate()).padStart(2, '0')}`;
            setDataPagamento(sugerido);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            await api.post('/Painel/API/Colaborador/UpdateFolga/', {
                id: folga.id,
                matricula: folga.matricula,
                data_folga: dataFolga,
                data_pagamento: pagamentoEditavel ? dataPagamento : toInputDate(folga.data_pagamento)
            });

            await fetchData();
            notifySuccess("Folga atualizada com sucesso.");
            closeModal();

        } catch (e) {
            console.error(e);
            const msg = e?.response?.data?.message || "Erro ao atualizar folga.";
            notifyError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Overlay state={true}>
                <Modal size="md" header={true} close={closeModal}>
                    <Formulario onSubmit={handleSubmit}>
                        <FormComp
                            title="DATA DA FOLGA"
                            type="date"
                            valor={dataFolga}
                            changeFunc={(e) => handleChangeDataFolga(e.target.value)}
                            required
                        />
                        <FormComp
                            title={
                                pagamentoEditavel
                                    ? "DATA DO PAGAMENTO"
                                    : "DATA DO PAGAMENTO (mês já encerrado — não editável)"
                            }
                            type="date"
                            valor={dataPagamento}
                            changeFunc={(e) => setDataPagamento(e.target.value)}
                            readOnly={!pagamentoEditavel}
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
            {loading && (
                <Overlay state={true}>
                    <Modal size="sm">
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </>
    );
};

export default ModalEditFolga;
